import { TextField, InputAdornment, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { evaluate } from 'mathjs';
import { useController } from 'react-hook-form';
import { formatFixedDecimal } from '../../utils/formatNumber';

CurrencyCalc.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  control: PropTypes.any,
};

export default function CurrencyCalc({ name, control, onChange, disabled = false , loading = false }) {
  const { field } = useController({ name, control });
  const [inputValue, setInputValue] = useState(field.value ?? 0);

  useEffect(() => {
    setInputValue(formatFixedDecimal(field.value ?? 0));
  }, [field.value]);

  function safeEvaluate(expression) {
    try {
      const result = evaluate(expression);
      return typeof result === 'number' && !Number.isNaN(result) ? parseFloat(result.toFixed(2)) : null;
    } catch (err) {
      return null;
    }
  }

  const handleEvaluate = () => {
    const rawInput = typeof inputValue === 'string' ? inputValue.replace(/[$,]/g, '').trim() : inputValue;

    const result = safeEvaluate(rawInput);

    if (result !== null) {
      field.onChange(result);
      onChange?.(result);
      setInputValue(formatFixedDecimal(result));
    } else {
      setInputValue(formatFixedDecimal(field.value ?? 0));
    }
  };

  return (
    <TextField
      name={name}
      variant="standard"
      value={inputValue ?? 0}
      disabled={disabled}
      inputRef={field.ref}
      onChange={(e) => {
        setInputValue(e.target.value || 0);
      }}
      autoComplete="off"
      onBlur={handleEvaluate}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleEvaluate();
        }
      }}
      sx={{ flexGrow: 1 }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <span style={{ fontSize: '12px' }}>$</span>
          </InputAdornment>
        ),
        endAdornment: <>{loading ? <CircularProgress color="inherit" size={16} /> : null}</>,
        sx: { fontSize: '12px' },
      }}
    />
  );
}
